export function isFeaturedHereEmpty(props) {
    return !props || !props.cards || props.cards.length === 0;
}
